import React from 'react'
import Dashboard from '../layout/Dashboard'
import About from '../layout/About'
import Client from '../layout/Client'
import Footer from '../layout/footer'
import Advertisement from '../layout/Advertisement'
import Slider from "../slider/Slider"
import Carousel from '../layout/Carousel'
import { Helmet } from 'react-helmet'

const Home = () => {

  // const fun = props.nav

  return (
    <div>
      <div id='bg'>
      <Helmet>
        <title>Vwrap | Outdoor Marketing & 360 Advertising Agency</title>
        <meta name="description" content="With extensive knowledge of how to catch people's attention, Vwrap brings you outdoor marketing and advertising services that are eye-catching and engaging!" />
      </Helmet>
        <Dashboard />
        <About />
        <Advertisement />
        <Client />
        <Footer />

        {/* <Carousel /> */}
      </div>

    </div>
  )
}

export default Home
